import { render } from "./SearchFilterItem.vue?vue&type=template&id=48980ab8"
import script from "./SearchFilterItem.vue?vue&type=script&lang=js"
export * from "./SearchFilterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__